module.exports = __webpack_public_path__ + "img/noInformation.f048936b.png";